import React from 'react';
import { IIconProps } from '../interfaces';

const WarningIcon = (props: IIconProps) => {

    const strokeWidth = props?.strokeWidth || 1;
    const strokeColor = props?.strokeColor || 'none';

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={ props.classes ?? undefined }
            width={ props.width }
            height={ props.width }
            style={ props.style }
            fill="none">
            <path
                fill={ props.color || '#000' }
                stroke={ strokeColor }
                strokeWidth={ strokeWidth }
                d="M21.39 12.727 14.974 2.23A4.688 4.688 0 0 0 11.001 0a4.683 4.683 0 0 0-3.973 2.23L.612 12.726A4.158 4.158 0 0 0 0 14.9a4.173 4.173 0 0 0 4.167 4.167h13.666A4.171 4.171 0 0 0 22 14.9c0-.766-.211-1.52-.612-2.173h.002ZM17.835 17.6H4.169a2.702 2.702 0 0 1-2.304-4.108L8.281 2.994a3.205 3.205 0 0 1 2.722-1.526 3.21 3.21 0 0 1 2.721 1.526l6.416 10.498a2.699 2.699 0 0 1-2.303 4.108h-.002Z"/>

            <path
                fill={ props.color || '#000' }
                stroke={ strokeColor }
                strokeWidth={ strokeWidth }
                d="M11 3.666a.734.734 0 0 0-.733.734v7.332a.734.734 0 0 0 1.468 0V4.4A.734.734 0 0 0 11 3.666ZM11 13.932a.734.734 0 0 0-.733.734v.733a.734.734 0 0 0 1.468 0v-.733a.734.734 0 0 0-.734-.734Z"/>
        </svg>
    )
};

export default WarningIcon;